import { Box, Flex } from '@chakra-ui/react';
import { Skeleton } from '@/components/ui/skeleton';

export function LoadingCardSkeleton() {
    return (
        <Box p="12px" borderWidth="1px" borderColor="border" borderRadius="md">
            <Flex flexDirection="column" gap="8px">
                <Skeleton height="4" width="60%" />
                <Skeleton height="3" width="40%" />
                <Flex gap="8px" pt="4px">
                    <Skeleton height="3" width="30%" />
                    <Skeleton height="3" width="30%" />
                </Flex>
            </Flex>
        </Box>
    );
}
